// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__1Wqs1","alertIcon":"ConfirmModal_alertIcon__3jmSg"};